export default __webpack_public_path__ + "static/media/jenkins.c5cba5ba.png";